/* Tuft Jo · Custom Rug Builder — interactive multi-step experience.
   Pricing: width_m × height_m × 150 JOD/m². Round +15%. Custom shape +20%. Flat (uncarved) -10%.
*/
(function(){
  const isAR = document.documentElement.lang === 'ar';
  const T = isAR ? {
    fmtPrice: n => `${n} د.أ`,
    sizeFmt: (w,h) => `${w} × ${h} سم`,
    next: 'التالي →', back: '← السابق',
    reviewQuote: '✓ راجع عرض السعر أدناه',
    inspirationLocked: 'تم اختيار الإلهام. الآن اختر المقاس.',
    fillFields: 'يرجى تعبئة الاسم والواتساب والبريد والمدينة.',
    openingWA: 'جاري فتح واتساب...',
    linkCopied: '✓ تم نسخ الرابط',
    copyFailed: 'تعذّر النسخ. الرابط: ',
    shapeNames: { rectangle:'مستطيل', square:'مربع', round:'دائري', custom:'مخصص' },
    pileNames: { carved:'منحوتة', flat:'مسطّحة' },
    hints: ['قطعة جانب السرير', 'سجادة جدارية أو بورتريه', 'غرفة أطفال أو ممرّ', 'سجادة غرفة معيشة', 'قطعة كبيرة — تغطّي زاوية كاملة'],
    breakdown: {
      base: (w,h) => `الحجم الأساسي · ${w}×${h} سم`,
      round: 'تعديل الشكل الدائري',
      custom: 'تعديل الشكل المخصّص',
      flat: 'خصم النهاية المسطّحة −١٠٪'
    }
  } : {
    fmtPrice: n => `JOD ${n}`,
    sizeFmt: (w,h) => `${w} × ${h} cm`,
    next: 'Next →', back: '← Back',
    reviewQuote: '✓ Review your quote below',
    inspirationLocked: 'Inspiration locked in. Now pick your size.',
    fillFields: 'Please fill in your name, WhatsApp, email and city.',
    openingWA: 'Opening WhatsApp...',
    linkCopied: '✓ Shareable link copied',
    copyFailed: 'Could not copy. Try manually: ',
    shapeNames: { rectangle:'Rectangle', square:'Square', round:'Round', custom:'Custom' },
    pileNames: { carved:'Carved', flat:'Flat' },
    hints: ['Bedside / desk piece', 'Wall hanging or pet portrait', 'Kids room or hallway runner', 'Living room area rug', 'Statement piece — covers a full room corner'],
    breakdown: {
      base: (w,h) => `Base size · ${w}×${h} cm`,
      round: 'Round shape adjustment',
      custom: 'Custom shape adjustment',
      flat: 'Flat (no carving) discount −10%'
    }
  };
  const STATE = {
    step: 1,
    shape: 'rectangle',
    pile: 'carved',
    w: 80, h: 60,
    files: [],
    notes: '',
    palette: ['#9C2426', '#FFC93C', '#FAF7F0', '#0A0A0A'],
    inspirationSlug: null,
  };

  // Load state from URL share if present
  const params = new URLSearchParams(location.search);
  if (params.get('cb')) {
    try {
      const decoded = JSON.parse(atob(params.get('cb')));
      Object.assign(STATE, decoded);
    } catch(e){}
  }

  // ============== INSPIRATION GALLERY (past customs) ==============
  const inspirationData = [
    { slug:'arabesque-tile', img:'1a2e24_1c18b44baacf46339e33699006bf42b8~mv2.jpeg', label:'Arabesque tile · 60×60' },
    { slug:'evil-eye', img:'1a2e24_68532590d6be4961b12419edb92ef2fc~mv2.jpg', label:'Evil eye · 50×50' },
    { slug:'palestine', img:'1a2e24_0c096f39f7914b659b6c4eec4b8be550~mv2.jpg', label:'Palestine · 90×60' },
    { slug:'rambo-the-dog', img:'1a2e24_1823cceb6f2f4406a2a953d6536479aa~mv2.jpg', label:'Rambo · pet portrait' },
    { slug:'nintendo-switch', img:'1a2e24_b002be399f444c73a2810f801aa57ee4~mv2.jpeg', label:'Switch · 90×50' },
    { slug:'color-palette', img:'1a2e24_095fae1812a44e8c87b476bdd1182ba3~mv2.jpeg', label:'Palette · 70cm round' },
    { slug:'starfish', img:'1a2e24_485804a50901432ca3e66b4936117721~mv2.jpg', label:'Starfish · 60×60 shape' },
    { slug:'stitch', img:'1a2e24_7e674086c77648c48774cc46f7e127f2~mv2.jpg', label:'Stitch · 80×60 shape' },
    { slug:'kermit', img:'1a2e24_ffd2469103f247ed9c0fb41e39506e27~mv2.jpg', label:'Kermit · 70×70' },
    { slug:'fino-the-cat', img:'1a2e24_dd40097a9e0b44dbb62071e1e13d596d~mv2.jpg', label:'Cat portrait · 60×80' },
    { slug:'james-sullivan', img:'1a2e24_4ab8a865eefb475cb09e35d82ad174cd~mv2.jpg', label:'Sulley · 90×90' },
    { slug:'sea-turtle', img:'1a2e24_ad3560d7518f463c99c6de0548b65117~mv2.jpg', label:'Sea turtle · 90×60' },
  ];
  const cdn = (file, w=300) => `https://static.wixstatic.com/media/${file}/v1/fit/w_${w},h_${w},q_85/file.jpg`;

  function renderInspiration() {
    const track = document.getElementById('cbInsp');
    if (!track) return;
    track.innerHTML = inspirationData.map(it => `
      <button type="button" class="cb-insp-card ${STATE.inspirationSlug === it.slug ? 'on':''}" data-slug="${it.slug}">
        <img src="${cdn(it.img,260)}" alt="${it.label}" loading="lazy"/>
        <span class="lab">${it.label}</span>
      </button>
    `).join('');
    track.querySelectorAll('.cb-insp-card').forEach(card => {
      card.addEventListener('click', () => {
        STATE.inspirationSlug = card.dataset.slug;
        track.querySelectorAll('.cb-insp-card').forEach(c => c.classList.remove('on'));
        card.classList.add('on');
        // jump to step 2 (size)
        goTo(2);
        window.tjToast('Inspiration locked in. Now pick your size.');
      });
    });
  }

  // ============== YARN LIBRARY ==============
  const YARN_COLORS = [
    '#9C2426','#DC0043','#FF8B5C','#FFC93C','#F4A93A','#FFD86B',
    '#1f7a3a','#6FAA66','#2A6FB8','#7FCCF7','#523B6E','#A0619F',
    '#FFFFFF','#FAF7F0','#E5E2D8','#999999','#3D3D3D','#0A0A0A',
    '#A66E4D','#D6B89F','#F4B25E','#BD3C3C','#26A69A','#F06292'
  ];

  function renderYarnLibrary() {
    const lib = document.getElementById('cbYarnLib');
    if (!lib) return;
    lib.innerHTML = YARN_COLORS.map(c => `<button type="button" class="cb-yarn ${STATE.palette.includes(c)?'on':''}" style="background:${c}" data-color="${c}" aria-label="Add ${c}"></button>`).join('');
    lib.querySelectorAll('.cb-yarn').forEach(y => {
      y.addEventListener('click', () => {
        const c = y.dataset.color;
        if (STATE.palette.includes(c)) {
          STATE.palette = STATE.palette.filter(x => x !== c);
        } else {
          STATE.palette.push(c);
        }
        renderPalette();
        renderYarnLibrary();
        update();
      });
    });
  }

  function renderPalette() {
    const pal = document.getElementById('cbPalette');
    if (!pal) return;
    if (STATE.palette.length === 0) {
      pal.innerHTML = '<span style="color:var(--muted);font-size:13.5px;font-weight:500">Tap a yarn color below to add it →</span>';
    } else {
      pal.innerHTML = STATE.palette.map(c =>
        `<button type="button" class="cb-swatch" style="background:${c}" data-color="${c}" aria-label="Remove ${c}"></button>`
      ).join('');
      pal.querySelectorAll('.cb-swatch').forEach(s => {
        s.addEventListener('click', () => {
          STATE.palette = STATE.palette.filter(x => x !== s.dataset.color);
          renderPalette(); renderYarnLibrary(); update();
        });
      });
    }
  }

  // ============== PRICING ENGINE ==============
  function calcPrice() {
    const wM = STATE.w / 100;
    const hM = STATE.h / 100;
    const baseArea = wM * hM;
    let base = baseArea * 150;
    // shape multiplier
    let shapeMul = 1.0;
    if (STATE.shape === 'round') { base = Math.PI * (Math.min(wM,hM)/2) ** 2 * 150; shapeMul = 1.0; }
    else if (STATE.shape === 'custom') shapeMul = 1.20;
    const shapedBase = base * shapeMul;
    // pile discount
    const pileMul = STATE.pile === 'flat' ? 0.90 : 1.0;
    const total = shapedBase * pileMul;
    // round to nearest JOD 5
    const rounded = Math.round(total / 5) * 5;
    return {
      area: baseArea,
      base: base,
      shaped: shapedBase,
      total: rounded,
      breakdown: [
        { label: T.breakdown.base(STATE.w, STATE.h), value: base },
        STATE.shape === 'round' ? { label: T.breakdown.round, value: shapedBase - base } :
          STATE.shape === 'custom' ? { label: T.breakdown.custom, value: shapedBase - base } : null,
        STATE.pile === 'flat' ? { label: T.breakdown.flat, value: -(shapedBase * 0.10), discount: true } : null
      ].filter(Boolean)
    };
  }

  // ============== UPDATE EVERYTHING ==============
  function update() {
    const price = calcPrice();
    // live quote on side
    const liveEl = document.getElementById('cbLivePrice');
    if (liveEl) liveEl.textContent = T.fmtPrice(price.total);
    const fillEl = document.getElementById('cbLiveFill');
    if (fillEl) {
      const pct = Math.min(100, (price.total / 500) * 100); // 500 JOD = 100% of the bar
      fillEl.style.width = pct + '%';
    }
    // preview meta
    const sizeEl = document.getElementById('cbPrevSize');
    if (sizeEl) sizeEl.textContent = T.sizeFmt(STATE.w, STATE.h);
    const shapeEl = document.getElementById('cbPrevShape');
    if (shapeEl) shapeEl.textContent = `${T.shapeNames[STATE.shape]} · ${T.pileNames[STATE.pile]}`;
    // SVG rug preview
    renderRugPreview();
    // size hint
    const hintEl = document.getElementById('cbSizeHint');
    if (hintEl) {
      const a = (STATE.w * STATE.h) / 10000; // m²
      let h = T.hints[0];
      if (a >= 0.25 && a < 0.6) h = T.hints[1];
      else if (a >= 0.6 && a < 1.5) h = T.hints[2];
      else if (a >= 1.5 && a < 2.8) h = T.hints[3];
      else if (a >= 2.8) h = T.hints[4];
      hintEl.textContent = `${h} · ${a.toFixed(2)} m² · ${T.fmtPrice(price.total)}`;
    }
    // step 6 quote breakdown
    const lines = document.getElementById('cbQuoteLines');
    if (lines) {
      lines.innerHTML = price.breakdown.map(b =>
        `<div class="cb-quote-line ${b.discount?'disc':''}"><span>${b.label}</span><b>${b.value < 0 ? '−' : ''}${T.fmtPrice(Math.abs(b.value).toFixed(0))}</b></div>`
      ).join('');
    }
    const totalEl = document.getElementById('cbQuotePrice');
    if (totalEl) totalEl.textContent = T.fmtPrice(price.total);
    // sync progress pills
    document.querySelectorAll('.cb-step-pill').forEach(p => {
      const s = parseInt(p.dataset.step, 10);
      p.classList.toggle('on', s === STATE.step);
      p.classList.toggle('done', s < STATE.step);
    });
  }

  // ============== SVG RUG PREVIEW (top-down room view) ==============
  function renderRugPreview() {
    const g = document.getElementById('cbRugShape');
    if (!g) return;
    // Map cm → SVG units. SVG viewBox is 400×280. Max dims: w 360, h 240.
    const scale = Math.min(360 / STATE.w, 240 / STATE.h);
    const sw = STATE.w * scale;
    const sh = STATE.h * scale;
    const cx = 200;
    const cy = 140;
    const x = cx - sw/2;
    const y = cy - sh/2;
    // base palette color for rug fill
    const fill = STATE.palette[0] || '#9C2426';
    const carved = STATE.pile === 'carved';
    const shadowColor = STATE.palette[1] || '#FFC93C';

    let shapePath = '';
    if (STATE.shape === 'rectangle' || STATE.shape === 'square') {
      shapePath = `<rect x="${x}" y="${y}" width="${sw}" height="${sh}" rx="6" fill="${fill}"/>`;
    } else if (STATE.shape === 'round') {
      const r = Math.min(sw, sh) / 2;
      shapePath = `<circle cx="${cx}" cy="${cy}" r="${r}" fill="${fill}"/>`;
    } else if (STATE.shape === 'custom') {
      // organic blob
      const r = Math.min(sw, sh) / 2;
      shapePath = `<path d="M ${cx-r*.95} ${cy-r*.5} C ${cx-r*1.1} ${cy-r*.9}, ${cx-r*.3} ${cy-r*1.05}, ${cx+r*.4} ${cy-r*.85} C ${cx+r*1.05} ${cy-r*.6}, ${cx+r*1.1} ${cy+r*.3}, ${cx+r*.7} ${cy+r*.85} C ${cx+r*.2} ${cy+r*1.05}, ${cx-r*.6} ${cy+r*.95}, ${cx-r*.85} ${cy+r*.4} C ${cx-r*1.1} ${cy-r*.05}, ${cx-r*1.05} ${cy-r*.3}, ${cx-r*.95} ${cy-r*.5} Z" fill="${fill}"/>`;
    }

    // overlay carved pattern (shadow speckles) if carved
    let overlay = '';
    if (carved) {
      // draw 4-6 lighter dots representing carving relief
      const blobs = [];
      for (let i = 0; i < 5; i++) {
        const bx = x + sw * (0.2 + Math.random()*0.6);
        const by = y + sh * (0.2 + Math.random()*0.6);
        const br = Math.min(sw,sh) * 0.06 + Math.random()*Math.min(sw,sh)*0.04;
        const c = STATE.palette[1 + i % Math.max(1, STATE.palette.length-1)] || shadowColor;
        blobs.push(`<circle cx="${bx}" cy="${by}" r="${br}" fill="${c}" opacity=".7"/>`);
      }
      overlay = blobs.join('');
    } else {
      // flat: subtle stripes
      overlay = `<rect x="${x}" y="${y}" width="${sw}" height="${sh}" fill="url(#flatStripe)" opacity=".22"/>`;
    }

    g.innerHTML = `
      <defs>
        <pattern id="flatStripe" patternUnits="userSpaceOnUse" width="6" height="6">
          <line x1="0" y1="0" x2="6" y2="6" stroke="rgba(255,255,255,.4)" stroke-width="1"/>
        </pattern>
      </defs>
      ${shapePath}
      ${overlay}
    `;
  }

  // ============== STEP NAVIGATION ==============
  function goTo(n) {
    STATE.step = Math.max(1, Math.min(6, n));
    document.querySelectorAll('.cb-step').forEach(s => s.classList.toggle('on', parseInt(s.dataset.step,10) === STATE.step));
    const backBtn = document.getElementById('cbBack');
    const nextBtn = document.getElementById('cbNext');
    backBtn.textContent = T.back;
    backBtn.disabled = STATE.step === 1;
    nextBtn.textContent = STATE.step === 6 ? T.reviewQuote : T.next;
    nextBtn.disabled = STATE.step === 6;
    update();
    // smooth scroll to top of step
    document.querySelector('.cb-builder').scrollIntoView({behavior:'smooth', block:'start'});
  }

  // ============== EVENT WIRING ==============
  document.addEventListener('DOMContentLoaded', () => {
    renderInspiration();
    renderYarnLibrary();
    renderPalette();

    // Step 1 — shape
    document.querySelectorAll('.cb-shape').forEach(b => b.addEventListener('click', () => {
      STATE.shape = b.dataset.shape;
      document.querySelectorAll('.cb-shape').forEach(x => x.classList.remove('on'));
      b.classList.add('on');
      update();
    }));

    // Step 2 — size
    const wIn = document.getElementById('cbW');
    const hIn = document.getElementById('cbH');
    const wRange = document.getElementById('cbWRange');
    const hRange = document.getElementById('cbHRange');
    const syncW = (v) => { STATE.w = parseInt(v,10) || 80; wIn.value = STATE.w; wRange.value = STATE.w; update(); };
    const syncH = (v) => { STATE.h = parseInt(v,10) || 60; hIn.value = STATE.h; hRange.value = STATE.h; update(); };
    wIn.addEventListener('input', e => syncW(e.target.value));
    hIn.addEventListener('input', e => syncH(e.target.value));
    wRange.addEventListener('input', e => syncW(e.target.value));
    hRange.addEventListener('input', e => syncH(e.target.value));
    document.querySelectorAll('.cb-preset').forEach(p => p.addEventListener('click', () => {
      syncW(p.dataset.w); syncH(p.dataset.h);
      document.querySelectorAll('.cb-preset').forEach(x => x.classList.remove('on'));
      p.classList.add('on');
    }));

    // Step 3 — pile
    document.querySelectorAll('.cb-pile').forEach(b => b.addEventListener('click', () => {
      STATE.pile = b.dataset.pile;
      document.querySelectorAll('.cb-pile').forEach(x => x.classList.remove('on'));
      b.classList.add('on');
      update();
    }));

    // Step 4 — upload
    const fileInput = document.getElementById('cbFile');
    const drop = document.querySelector('.cb-drop');
    const thumbs = document.getElementById('cbThumbs');
    const renderThumbs = () => {
      thumbs.innerHTML = STATE.files.map((f,i) => `
        <div class="cb-thumb" data-idx="${i}">
          <img src="${f.url}" alt=""/>
          <span class="rm">×</span>
        </div>`).join('');
      thumbs.querySelectorAll('.rm').forEach(r => r.addEventListener('click', (e) => {
        const idx = parseInt(e.target.parentElement.dataset.idx, 10);
        STATE.files.splice(idx, 1);
        renderThumbs();
      }));
    };
    fileInput.addEventListener('change', (e) => {
      [...e.target.files].forEach(f => {
        const url = URL.createObjectURL(f);
        STATE.files.push({ name: f.name, size: f.size, url });
      });
      renderThumbs();
    });
    drop.addEventListener('dragover', (e) => { e.preventDefault(); drop.classList.add('drag-over'); });
    drop.addEventListener('dragleave', () => drop.classList.remove('drag-over'));
    drop.addEventListener('drop', (e) => {
      e.preventDefault(); drop.classList.remove('drag-over');
      [...e.dataTransfer.files].forEach(f => {
        if (!f.type.startsWith('image/')) return;
        const url = URL.createObjectURL(f);
        STATE.files.push({ name: f.name, size: f.size, url });
      });
      renderThumbs();
    });
    document.getElementById('cbNotes').addEventListener('input', (e) => { STATE.notes = e.target.value; });

    // Step navigation
    document.getElementById('cbNext').addEventListener('click', () => goTo(STATE.step + 1));
    document.getElementById('cbBack').addEventListener('click', () => goTo(STATE.step - 1));
    document.querySelectorAll('.cb-step-pill').forEach(p => p.addEventListener('click', () => {
      const s = parseInt(p.dataset.step, 10);
      // allow jumping to any step that's been reached
      if (s <= STATE.step + 1) goTo(s);
    }));

    // Step 6 — Send via WhatsApp
    document.getElementById('cbSend').addEventListener('click', () => {
      const name = document.getElementById('cbName').value.trim();
      const phone = document.getElementById('cbPhone').value.trim();
      const email = document.getElementById('cbEmail').value.trim();
      const city = document.getElementById('cbCity').value.trim();
      if (!name || !phone || !email || !city) {
        window.tjToast('Please fill in your name, WhatsApp, email and city.', { error: true });
        return;
      }
      const price = calcPrice();
      const palette = STATE.palette.join(' ');
      const insp = STATE.inspirationSlug ? `Inspiration ref: ${STATE.inspirationSlug}\n` : '';
      const message =
        `Hi Tuft.jo — I'd like to order a custom rug:\n\n` +
        `▸ Shape: ${STATE.shape}\n` +
        `▸ Size: ${STATE.w} × ${STATE.h} cm\n` +
        `▸ Style: ${STATE.pile}\n` +
        `▸ Palette: ${palette}\n` +
        `▸ Estimated quote: JOD ${price.total}\n` +
        insp +
        (STATE.notes ? `▸ Notes: ${STATE.notes}\n` : '') +
        `\nMy details:\nName: ${name}\nPhone: ${phone}\nEmail: ${email}\nCity: ${city}\n\n` +
        `(Sent from the custom rug builder)`;
      const wa = `https://wa.me/962791322281?text=${encodeURIComponent(message)}`;
      window.tjToast('Opening WhatsApp...');
      setTimeout(() => window.open(wa, '_blank'), 400);
    });

    // Share link
    document.getElementById('cbShare').addEventListener('click', async () => {
      const compact = { shape:STATE.shape, pile:STATE.pile, w:STATE.w, h:STATE.h, palette:STATE.palette, inspirationSlug:STATE.inspirationSlug };
      const url = `${location.origin}${location.pathname}?cb=${btoa(JSON.stringify(compact))}`;
      try {
        await navigator.clipboard.writeText(url);
        window.tjToast('✓ Shareable link copied');
      } catch(e) {
        window.tjToast('Could not copy. Try manually: ' + url);
      }
    });

    // Initial render
    update();
    goTo(STATE.step);
  });
})();
